import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Link = ({ linkURL, text, footer, ...otherProps }) => {
    var cssClass = classNames({
        link: true,
        isFooterLink: footer
    });

    return (
        <a {...otherProps} href={linkURL} target="_blank" className={cssClass}>
            {text ? text : linkURL}
        </a>
    );
};

Link.propTypes = {
    linkURL: PropTypes.string.isRequired,
    text: PropTypes.string
};

export default Link;



// WEBPACK FOOTER //
// ./src/components/Link/Link.jsx